import { Component, Input } from '@angular/core';
import { CustomTooltipDirection } from '../../custom-tooltip/custom-tooltip';

@Component({
  selector: 'ps-ui-aida-chart-tooltip',
  template: `
    <div>
      <div style="display: flex">
        <svg
          width="13"
          height="9"
          viewBox="0 0 13 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.68912 7.87641C6.9 8.42947 6.91175 8.42946 7.31088 7.87641L11.8512 1.5852C12.3285 0.92384 11.8559 0 11.0403 0H1.95972C1.14411 0 0.671535 0.923841 1.14883 1.58521L5.68912 7.87641Z"
            fill="#333333"
          />
        </svg>
        <div class="title-text-style">Current Completes</div>
      </div>
      <div>
        <div style="display: flex">
          <svg
            width="12"
            height="13"
            viewBox="0 0 12 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="5.5"
              y1="12.5"
              x2="5.5"
              y2="1.5"
              stroke="#757575"
              stroke-linecap="round"
            />
          </svg>

          <div class="title-text-style">Project Goal</div>
        </div>
        <div class="pace-state-text-style">Pacing states</div>
        <div class="pace-state-details-orientation">
          <div class="square" style="background-color: #ed6b76;"></div>
          <div class="pace-state-details">Danger: underperforming</div>
        </div>
        <div class="pace-state-details-orientation">
          <div class="square" style="background-color: #eedb53;"></div>
          <div class="pace-state-details">Warning: moderate performance</div>
        </div>
        <div class="pace-state-details-orientation">
          <div class="square" style="background-color: #71ac82;"></div>
          <div class="pace-state-details">Success: overperforming</div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./aida-chart-tooltip.component.css'],
})
export class AidaChartToolTipComponent {
  @Input()
  public direction: CustomTooltipDirection = 'right';
}
